if (typeof loadeMoreSlider_G === 'undefined') {
  globalThis.loadeMoreSlider_G = null;
}

(function () {
  const initSlider = () => {
    const sliders = document.querySelectorAll(".product-card-js");
    const dir = document.querySelector('html').getAttribute("dir");

    let nextEl = ".product-button-group .swiper-button-next";
    let prevEl = ".product-button-group .swiper-button-prev";
    if (dir === 'rtl') {
      [nextEl, prevEl] = [prevEl, nextEl];
    }
    sliders.forEach((slider, index) => {
      if (slider?.swiper) return;

      const productSlider = new Swiper(slider, {
        initialSlide: 0,
        pagination: {
          el: ".product-pagination .swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: nextEl,
          prevEl: prevEl,
        },
        roundLengths: true,
        threshold: 10,
        allowTouchMove: true,
        990: {
          allowTouchMove: false,
        },
      });

      /* MK: open the product page on the photo actually tapped */
      slider.addEventListener('click', function (e) {
        /* MK 7 oct. 2026 (K) : adresse propre, sans « #pcimg-… » ; la photo touchée est transmise à la fiche par sessionStorage */
          var mkAnchor = e.target.closest('a[data-mk-pcimg]');
        if (!mkAnchor) { return; }
        var mkIdx = null;
        try {
          var mkSlide = e.target.closest('.swiper-slide');
          if (mkSlide) {
            if (productSlider && productSlider.slides) {
              var mkPos = [].slice.call(productSlider.slides).indexOf(mkSlide);
              if (mkPos > -1) { mkIdx = mkPos; }
            }
            if (mkIdx === null && mkSlide.parentElement) {
              var mkSibs = [].slice.call(mkSlide.parentElement.children).filter(function (mkEl) {
                return mkEl.classList && mkEl.classList.contains('swiper-slide');
              });
              var mkPos2 = mkSibs.indexOf(mkSlide);
              if (mkPos2 > -1) { mkIdx = mkPos2; }
            }
          }
        } catch (mkErr) {}
        if (mkIdx === null && productSlider && typeof productSlider.activeIndex === 'number') {
          mkIdx = productSlider.activeIndex;
        }
        if (mkIdx === null || isNaN(mkIdx)) { mkIdx = parseInt(mkAnchor.getAttribute('data-mk-pcimg'), 10) || 0; }
          try {
            var mkHandle = (mkAnchor.pathname.split('/products/')[1] || '').split('/')[0];
            sessionStorage.setItem('mk_pcimg', JSON.stringify({ h: mkHandle, i: mkIdx, t: Date.now() }));
          } catch (mkErr2) {}
      }, true);
    });
  };

  initSlider();
  loadeMoreSlider_G = initSlider;

  document.addEventListener("shopify:section:load", function () {
    initSlider();
  });
})();


/* MK: card photos after the first one load lazily (lighter pages); as soon as the visitor points at, touches or tabs into a card, its other photos start loading so swiping stays instant */
(function () {
  function warm(e) {
    var card = e.target && e.target.closest ? e.target.closest('.product-card-js') : null;
    if (!card || card.__mkWarm) return;
    card.__mkWarm = true;
    card.querySelectorAll('img[loading="lazy"]').forEach(function (img) { img.loading = 'eager'; });
  }
  document.addEventListener('pointerover', warm, { passive: true });
  document.addEventListener('touchstart', warm, { passive: true });
  document.addEventListener('focusin', warm);
})();
